import React from 'react'
import { useSelector } from "react-redux";
import {
    Chart as ChartJs,
    LineElement,
    CategoryScale, // x axis
    LinearScale, //y axis
    PointElement

} from 'chart.js/auto'
import { Line } from 'react-chartjs-2';
ChartJs.register(
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement
)


export default function LineChart({ dashboardId }) {

    const dashboardData = useSelector(state => state.dashboardReducer.userDashboard.userdashboardData);
    if (dashboardData === null) {
        return <div />;
    }
    let datas = dashboardData[dashboardId];
    let dataRows = datas.dataRows;
    if(dataRows.length===0){
        return <div></div>;
    }

    // Group the data by label and series description
    const groupedData = dataRows.reduce((acc, curr) => {
        const label = curr.fields.find(field => field.fieldName === 'CHARTLABEL').fieldValue;
        const value = curr.fields.find(field => field.fieldName === 'CHARTVALUE').fieldValue;
        const series = curr.fields.find(field => field.fieldName === 'SERIESDESC').fieldValue;
        if (!acc[label]) {
            acc[label] = {};
        }
        acc[label][series] = value;
        return acc;
    }, {});

    function getRandomColor(alpha = 1) {
        const r = Math.floor(Math.random() * 256);
        const g = Math.floor(Math.random() * 256);
        const b = Math.floor(Math.random() * 256);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
    const labels = Object.keys(groupedData).sort(); // Sort labels in ascending order
    const datasets = Object.keys(groupedData[labels[0]]).map(series => ({
        label: series,
        backgroundColor: getRandomColor(0.6),
        borderColor: getRandomColor(0.9),
        pointBorderColor: getRandomColor(0.8),
        data: labels.map(label => groupedData[label][series] || 0)
    }));

    const options = {
        /*responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },

        },
        scale: {
            y: {
                //min: 3,
                //max: 6
            }
        },
        */
    }
    return (
        <div class="col-xl-6">
            <div class="card">
                <div class="card-body">
                <div className="alert alert-primary" role="alert">
                        <h4> <i className='mdi mdi-chart-line'></i> {datas.dashboardTitle} </h4>
                    </div>
                    <div dir="ltr">
                        <div>
                            <Line data={{ labels, datasets }} options={options} >
                            </Line>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    )
}
